import { render, staticRenderFns } from "./excessive.vue?vue&type=template&id=210f84ed&scoped=true"
import script from "./excessive.vue?vue&type=script&lang=js"
export * from "./excessive.vue?vue&type=script&lang=js"
import style0 from "./excessive.vue?vue&type=style&index=0&id=210f84ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f84ed",
  null
  
)

export default component.exports